import { Resource } from "../resource/Resource";
import { Utils } from "../utils/Utils";
let _tmpInfo = { text: "" };
function myT(resources, name, defaultValue, options) {
    if (typeof (defaultValue) === "object") {
        options = defaultValue;
        defaultValue = "";
    }
    let ent = resources[name];
    if (!ent)
        return defaultValue;
    if (options)
        return Utils.parseTemplate(ent, options);
    else
        return ent;
}
class SimpleProvider {
    constructor() {
        var _a;
        this.isInitialized = true;
        this.language = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.language) || "en";
        this._content = {};
        this._t = myT.bind(null, {});
    }
    t(name, defaultValue, options) {
        return this._t(name, defaultValue, options);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let col = this._content[lng];
        if (!col)
            col = this._content[lng] = {};
        let func = myT.bind(null, resources);
        if (lng === this.language)
            this._t = func;
        col[ns] = { resources, t: func };
    }
    removeResourceBundle(lng, ns) {
        let col = this._content[lng];
        if (col)
            delete col[ns];
    }
    getFixedT(lng, ns) {
        var _a;
        let col = (_a = this._content[lng]) === null || _a === void 0 ? void 0 : _a[ns];
        if (col)
            return col.t;
        else
            return this._t;
    }
}
export class Translations extends Resource {
    static getById(id) {
        return Translations._allInsts.get(id) || null;
    }
    static create(id, fallbackLng) {
        return new Translations(id, fallbackLng);
    }
    static translate(text, options) {
        Translations.decodeI18nText(text, _tmpInfo);
        let i18n;
        if (_tmpInfo.sid)
            i18n = Translations.getById(_tmpInfo.sid);
        else if (_tmpInfo.key)
            i18n = Translations.provider;
        if (i18n)
            text = i18n.t(_tmpInfo.key, _tmpInfo.text, options !== null && options !== void 0 ? options : undefined);
        return text;
    }
    static decodeI18nText(text, out) {
        out = out || {};
        if (!text || !text.startsWith("i18n:")) {
            out.sid = null;
            out.key = null;
            out.text = text;
            return out;
        }
        let i = text.indexOf(":", 5);
        let j = text.indexOf("|", 5);
        if (i != -1) {
            out.sid = text.substring(5, i);
            if (j != -1) {
                out.key = text.substring(i + 1, j);
                out.text = text.substring(j + 1);
            }
            else {
                out.key = text.substring(i + 1);
                out.text = null;
            }
        }
        else if (j != -1) {
            out.sid = null;
            out.key = text.substring(5, j);
            out.text = text.substring(j + 1);
        }
        else {
            out.sid = null;
            out.key = text.substring(5);
            out.text = null;
        }
        return out;
    }
    static encodeI18nText(info, newText) {
        var _a;
        if (newText == null)
            newText = (_a = info.text) !== null && _a !== void 0 ? _a : "";
        if (!info.key)
            return newText;
        if (info.sid)
            return "i18n:" + info.sid + ":" + info.key + "|" + newText;
        else
            return "i18n:" + info.key + "|" + newText;
    }
    constructor(id, fallbackLng) {
        super(false);
        this._id2 = id;
        Translations._allInsts.set(id, this);
        this._lngs = [];
        this._fallbackLng = fallbackLng || "en";
    }
    get id() {
        return this._id;
    }
    setContent(lng, content) {
        let i18n = Translations.provider;
        if (!i18n || !i18n.isInitialized) {
            console.error("no i18n provider or i18 is not initialized");
            return this;
        }
        if (!lng)
            lng = i18n.language;
        Translations.provider.addResourceBundle(lng, this._id2, content, true, true);
        if (this._lngs.indexOf(lng) == -1)
            this._lngs.push(lng);
        if (lng == i18n.language)
            this._t = i18n.getFixedT(i18n.language, this._id2);
        else if (!this._t && lng == this._fallbackLng)
            this._t = i18n.getFixedT(this._fallbackLng, this._id2);
        return this;
    }
    t(name, arg0, arg1) {
        if (this._t)
            return this._t(name, arg0, arg1);
        else if (typeof (arg0) === "string")
            return arg0;
        else
            return name;
    }
    _disposeResource() {
        super._disposeResource();
        Translations._allInsts.delete(this._id2);
        for (let lng of this._lngs)
            Translations.provider.removeResourceBundle(lng, this._id2);
    }
}
Translations.provider = new SimpleProvider();
Translations._allInsts = new Map();
